import { render, staticRenderFns } from "./prodLink.vue?vue&type=template&id=1e1557ca&scoped=true&"
import script from "./prodLink.vue?vue&type=script&lang=js&"
export * from "./prodLink.vue?vue&type=script&lang=js&"
import style0 from "./prodLink.vue?vue&type=style&index=0&id=1e1557ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1557ca",
  null
  
)

export default component.exports